import {
  CATEGORY_ADMIN_ADD_FAVOURITE,
  CATEGORY_ADMIN_FETCH_ALL_CONTACT,
  CATEGORY_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  CATEGORY_ADMIN_FILTER_CONTACT,
  CATEGORY_ADMIN_GET_ALL_CONTACT,
  CATEGORY_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  CATEGORY_ADMIN_HANDLE_REQUEST_CLOSE,
  CATEGORY_ADMIN_HIDE_CONTACT_LOADER,
  CATEGORY_ADMIN_ON_ADD_CONTACT,
  CATEGORY_ADMIN_ON_ALL_CONTACT_SELECT,
  CATEGORY_ADMIN_ON_CONTACT_CLOSE,
  CATEGORY_ADMIN_ON_CONTACT_SELECT,
  CATEGORY_ADMIN_ON_DELETE_CONTACT,
  CATEGORY_ADMIN_ON_DELETE_SELECTED_CONTACT,
  CATEGORY_ADMIN_ON_FILTER_OPTION_SELECT,
  CATEGORY_ADMIN_ON_SAVE_CONTACT,
  CATEGORY_ADMIN_ON_TOGGLE_DRAWER,
  CATEGORY_ADMIN_SHOW_MESSAGE,
  CATEGORY_ADMIN_UPDATE_SEARCH_USER,
  CHANGE_CATEGORY_ADMIN_DISPLAY,
  SET_CATEGORY_IMAGE_FILE,
  SUBMIT_NEW_CATEGORY_ADMIN,
  SUBMIT_NEW_CATEGORY_ADMIN_RESPONSE,
  FILL_ADMIN_CATEGORY_SELECTED_DETAILS,
  CHANGE_ADD_CATEGORY_STATE,
  CHANGE_EDIT_CATEGORY_STATE,
  SUBMIT_EDIT_CATEGORY_DETAILS,
  SUBMIT_EDIT_CATEGORY_DETAILS_RESPONSE,
  CATEGORY_CLEAR_FORM_DATA,
  SELECTED_CATEGORY_DELETE,
  SELECTED_CATEGORY_DELETE_RESPONSE,
  CATEGORY_SUPER_ADMIN_FETCH_ALL_CONTACT,
  SUBMIT_NEW_CATEGORY_SUPER_ADMIN,
  SELECTED_CATEGORY_DELETE_SUPER_ADMIN,
  CATEGORY_ADMIN_SHOW_CONTACT_LOADER,
  DELETE_CATEGORY_SUPER_ADMIN,
  CATEGORY_FAIL_RESPONSE
} from "../constants/ActionTypes";

export const categoryAdminFetchContacts = () => ({
  type: CATEGORY_ADMIN_FETCH_ALL_CONTACT,
});

export const categorySuperAdminFetchContacts = () => ({
  type: CATEGORY_SUPER_ADMIN_FETCH_ALL_CONTACT,
});

export const categoryAdminFetchContactsSuccess = contact => ({
  type: CATEGORY_ADMIN_FETCH_ALL_CONTACT_SUCCESS,
  payload: contact,
});
export const categoryAdminShowContactMessage = message => ({
  type: CATEGORY_ADMIN_SHOW_MESSAGE,
  payload: message,
});
export const categoryAdminAddFavourite = data => ({
  type: CATEGORY_ADMIN_ADD_FAVOURITE,
  payload: data,
});
export const categoryAdminOnContactSelect = data => ({
  type: CATEGORY_ADMIN_ON_CONTACT_SELECT,
  payload: data,
});

export const categoryAdminOnAddContact = () => ({
  type: CATEGORY_ADMIN_ON_ADD_CONTACT,
  payload: "",
});
export const categoryAdminOnContactClose = () => ({
  type: CATEGORY_ADMIN_ON_CONTACT_CLOSE,
  payload: "",
});
export const categoryAdminOnFilterOptionSelect = option => ({
  type: CATEGORY_ADMIN_ON_FILTER_OPTION_SELECT,
  payload: option,
});
export const categoryAdminOnSaveContact = data => ({
  type: CATEGORY_ADMIN_ON_SAVE_CONTACT,
  payload: data,
});
export const categoryAdminOnDeleteContact = data => ({
  type: CATEGORY_ADMIN_ON_DELETE_CONTACT,
  payload: data,
});
export const categoryAdminOnDeleteSelectedContact = () => ({
  type: CATEGORY_ADMIN_ON_DELETE_SELECTED_CONTACT,
  payload: "",
});
export const categoryAdminFilterContact = userName => ({
  type: CATEGORY_ADMIN_FILTER_CONTACT,
  payload: userName,
});
export const categoryAdminGetAllContact = () => ({
  type: CATEGORY_ADMIN_GET_ALL_CONTACT,
  payload: "",
});
export const categoryAdminGetUnselectedAllContact = () => ({
  type: CATEGORY_ADMIN_GET_UNSELECTED_ALL_CONTACT,
  payload: "",
});
export const categoryAdminOnAllContactSelect = () => ({
  type: CATEGORY_ADMIN_ON_ALL_CONTACT_SELECT,
  payload: "",
});
export const categoryAdminUpdateContactUser = userName => ({
  type: CATEGORY_ADMIN_UPDATE_SEARCH_USER,
  payload: userName,
});
export const categoryAdminOnToggleDrawer = () => ({
  type: CATEGORY_ADMIN_ON_TOGGLE_DRAWER,
});
export const categoryAdminHandleRequestClose = () => ({
  type: CATEGORY_ADMIN_HANDLE_REQUEST_CLOSE,
});
export const categoryAdminHideContactLoader = () => ({
  type: CATEGORY_ADMIN_HIDE_CONTACT_LOADER,
});
export const categoryAdminShowContactLoader = () => ({
  type: CATEGORY_ADMIN_SHOW_CONTACT_LOADER,
});

export const changeCategoryAdminDisplay = payload => ({
  type: CHANGE_CATEGORY_ADMIN_DISPLAY,
  payload,
});

export const submitNewCategoryAdmin = payload => ({
  type: SUBMIT_NEW_CATEGORY_ADMIN,
  payload,
});

export const submitNewCategorySuperAdmin = payload => ({
  type: SUBMIT_NEW_CATEGORY_SUPER_ADMIN,
  payload,
});

export const submitNewCategoryAdminResponse = payload => ({
  type: SUBMIT_NEW_CATEGORY_ADMIN_RESPONSE,
  payload,
});

export const fillAdminCategorySelctedDetails = payload => ({
  type: FILL_ADMIN_CATEGORY_SELECTED_DETAILS,
  payload,
});

export const changeAddCategoryState = payload => ({
  type: CHANGE_ADD_CATEGORY_STATE,
  payload,
});

export const changeEditCategoryState = payload => ({
  type: CHANGE_EDIT_CATEGORY_STATE,
  payload,
});

export const submitEditCategoryDetails = payload => ({
  type: SUBMIT_EDIT_CATEGORY_DETAILS,
  payload,
});

export const submitEditCategoryDetailsResponse = payload => ({
  type: SUBMIT_EDIT_CATEGORY_DETAILS_RESPONSE,
  payload,
});

export const categoryClearFormData = () => ({
  type: CATEGORY_CLEAR_FORM_DATA,
});

export const selectedCategoryDelete = payload => ({
  type: SELECTED_CATEGORY_DELETE,
  payload,
});

export const selectedCategoryDeleteSuperAdmin = payload => ({
  type: SELECTED_CATEGORY_DELETE_SUPER_ADMIN,
  payload,
});

export const selectedCategoryDeleteResposne = payload => ({
  type: SELECTED_CATEGORY_DELETE_RESPONSE,
  payload
});

export const deleteCategorySuperAdmin = payload => ({
  type: DELETE_CATEGORY_SUPER_ADMIN,
  payload,
});

export const categoryFailResponse = payload => ({
  type: CATEGORY_FAIL_RESPONSE,
  payload,
});


// WEBPACK FOOTER //
// ./actions/CategoryAdminActions.js